import React, { useState } from 'react';
import { AppContextProvider } from './AppContext';
import moment from 'moment';

function AppContextContainer({ children }) {
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [filters, setFilters] = useState([]);
    const [ispSelected, setIspSelected] = useState('');
    const [startDate, setStartDate] = useState(moment(new Date()).format('YYYY-MM-DD'));
    const [endDate, setEndDate] = useState(moment(new Date()).format('YYYY-MM-DD'));

    const contextValues = {
        data,
        setData,
        filteredData,
        setFilteredData,
        filters,
        setFilters,
        ispSelected,
        setIspSelected,
        startDate,
        setStartDate,
        endDate,
        setEndDate
    };

    return <AppContextProvider value={contextValues}>{children}</AppContextProvider>;
}

export default AppContextContainer;
